export default [
  {
    title: "Adjust Point",
    customIcon: "CustomSVG",
    children: [
      {
        title: "Adjust User",
        route: "custom-adjust-user-list",
        path: "/custom-adjust-user/list",
      },
      {
        title: "User Import File",
        route: "custom-user-import-file-list",
        path: "/custom-user-import-file/list",
      },
    ],
  },
];
